// extracted by mini-css-extract-plugin
export default {"closeBtn":"closeBtn_closeBtn__hoYeC"};